import { pushToDataLayer } from "@/helpers/gtag";
import styles from "./GraduationCard.module.scss";
import { getGlobalStateValue } from "@/context/utils";
import ArrowSVG from "@/SvgIcons/ArrowDown";
import Image from "next/image";

export default function GraduationCard({
  data,
  openSection,
  setOpenSection,
  heading,
  isCampusImmersionPage
}: {
  data: { Title: string; Subtitle: string; Image: { data: Media } }[];
  openSection: number | null;
  setOpenSection: (index: number | null) => void;
  heading: string
  isCampusImmersionPage:boolean;
}) {

  const toggleSection = (index: number | null) => {
    setOpenSection(openSection === index ? null : index);
  };

  const handleGAEvents = ({ title, index }: { title: string; index: number }) => {
      pushToDataLayer({
        event: "card_details_interaction",
      cta_text: title || "NA",
        section_name: heading || "NA",
      action: openSection === index ? "Collapse" : "Expand",
      page_type: getGlobalStateValue("pageType"),
      });
  };


  return (
    <>
      {data?.map((item, index) => (
        <div key={index}  className={`${styles.root} `}>
           {isCampusImmersionPage && <hr className="my-4 border-t-[1px] border-[#E7E7E7]-300" />}
          <div
            key={index}
            className={isCampusImmersionPage?'font-raleway':`lining-nums  py-6 ${
              openSection !== index
                ? "border-b-1 border-[#E7E7E7]"
                : styles.GraduationCard__shadow
            }  lg:py-6 lg:py-6 lg:mt-0 xl:mt-0 ${
              index === data.length - 1 && "lg:mb-0 xl:mb-0"
            }`}
          >
            {/* Title */}
            <div
              className="cursor-pointer flex justify-between items-center text-primary-blue "
              onClick={() => {
                toggleSection(index)
                handleGAEvents({ title: item.Title, index })
              }}
            >
              <h3
                className={` capitalize w-4/5 ${
                  openSection === index
                    ? `${styles.GraduationCard__Title}`
                    : `${styles.GraduationCard__OpenSectionTitle}`
                } `}
              >
                {item.Title}
              </h3>
              <span className={styles.icon}>
                    <ArrowSVG
                      id={`arrow-icon-${index}`}
                      rotate={openSection === index ? 180 : 0}
                      width={16}
                      height={16}
                      isActive={openSection === index} 
                      color="blue"
                    />
              </span>
            </div>
            {/* Subtitle */}
            {openSection === index && (
              <div className={isCampusImmersionPage?'':"flex  gap-3 justify-between items-center mt-3  lg:gap-[6.125rem]"}>
                <p className={isCampusImmersionPage?styles.Emmursion__SubTitle:styles.GraduationCard__SubTitle}>
                  {item.Subtitle}
                </p>
               {!isCampusImmersionPage &&  <Image
                  src={item?.Image?.data?.attributes?.url}
                  alt={item?.Image?.data?.attributes?.alternativeText || 'Amity Online'}
                  title="Amity Online"
                  className="lg:h-[3.33rem] lg:w-[3.66rem] xl:h-[4.25rem] xl:w-[4.875rem]"
                  loading="lazy"
                  width={469}
                  height={409}
                />}
              </div>
            )}
          </div>
        </div>
      ))}
      {isCampusImmersionPage && <hr className="my-4 border-t-[1px] border-gray-300" />}
    </>
  );
}
